module.exports = __webpack_public_path__ + "assets/img/4.fce93f07.png";